import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Grid } from '@app/core/components/grid/grid.model';
import { GridOptions } from '@app/core/components/grid/grid.types';

@Component({
    selector: 'tt-projects-grid',
    templateUrl: './projects-grid.component.html',
    styleUrls: ['./projects-grid.component.css'],
})
export class ProjectsGridComponent implements OnChanges {
    @Input()
    public rememberId: string = 'w_projects_grid';

    @Input()
    public params?: ProjectsGridParams;

    @Output()
    public gridReady = new EventEmitter<GridOptions>();

    public grid?: GridOptions;

    public readGrid() {
        if (!this.params) {
            console.warn('Projects grid needs parameters');
            return;
        }

        if (!this.grid) {
            this.grid = new Grid().setRememberId(this.rememberId).setLoadDataFunction({ method: 2748, parameters: () => this.params });
        } else {
            this.grid.gridfunc?.read();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!!changes['params']) {
            if (this.validProjectGridParams(changes['params'].currentValue)) {
                this.readGrid();
            } else {
                console.error('Invalid project grid parameters');
                console.dir(changes['params'].currentValue);
            }
        }
    }

    private validProjectGridParams(params: unknown): params is ProjectsGridParams {
        return !!params && typeof params === 'object' && 'argtype' in params && !!params.argtype && typeof params.argtype === 'string' && 'argvalue' in params && ['string', 'number'].includes(typeof params.argvalue) && 'bg_projects_activestatus' in params && !!params.bg_projects_activestatus && typeof params.bg_projects_activestatus === 'string' && ['ALL', 'NOTACTIVE', 'ACTIVE'].includes(params.bg_projects_activestatus.toUpperCase());
    }
}

export interface ProjectsGridParams {
    searchtext?: string;
    businessco_no?: string | number;
    argtype: string;
    argvalue: string | number;
    bg_projects_activestatus: 'ALL' | 'ACTIVE' | 'NOTACTIVE';
    webpage_name?: string;
}
